import { render, staticRenderFns } from "./BookingDetailPage.vue?vue&type=template&id=dd2db29c&scoped=true&"
import script from "./BookingDetailPage.vue?vue&type=script&lang=js&"
export * from "./BookingDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2db29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd2db29c')) {
      api.createRecord('dd2db29c', component.options)
    } else {
      api.reload('dd2db29c', component.options)
    }
    module.hot.accept("./BookingDetailPage.vue?vue&type=template&id=dd2db29c&scoped=true&", function () {
      api.rerender('dd2db29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/BookingDetailPage.vue"
export default component.exports